import Tarjeta from "./components/Tarjeta";
import { Grid } from "@material-ui/core";
import Tablero from "views/Tablero";
function Dashboard() {
  return <Tablero />;
}

export default Dashboard;
